(() => {
  if (!window.location.pathname.includes('/policies/')) return;

  const policy = document.querySelector('.shopify-policy__body .rte');
  if (!policy) return;

  policy.querySelectorAll('p').forEach((paragraph) => {
    const text = paragraph.textContent.trim();

    if (text === '---') {
      paragraph.remove();
      return;
    }

    if (text.startsWith('## ')) {
      const heading = document.createElement('h2');
      heading.textContent = text.slice(3).trim();
      paragraph.replaceWith(heading);
    }
  });

  const textNodes = [];
  const walker = document.createTreeWalker(policy, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((node) => {
    const value = node.nodeValue;
    if (!value || !value.includes('**')) return;

    const fragment = document.createDocumentFragment();
    const parts = value.split(/(\*\*[^*]+\*\*)/g);

    parts.forEach((part) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        const strong = document.createElement('strong');
        strong.textContent = part.slice(2, -2);
        fragment.appendChild(strong);
      } else if (part) {
        fragment.appendChild(document.createTextNode(part));
      }
    });

    node.replaceWith(fragment);
  });
})();
